import _ from "underscore";
import {filterLineItems} from "../components/common/utils";

const initialState = {
    product: null,
    products: [],
    plpTotalProducts: 0,
    plpTotalSearchProducts: 0,
    plpPage: '1',
    recently_viewed_products: [],
    similar_to_products: [],
    similar_to_products_total: 0,
    similar_to_filter_query: null,
    similar_to_products_loaded: false,
    similar_other_products: [],
    similar_other_products_total: 0,
    similar_other_filter_query: null,
    similar_other_products_loaded: false,
    matching_accessories: [],
    matching_accessories_total: 0,
    matching_accessories_filter_query: null,
    matching_accessories_loaded: false,
    matching_bags: [],
    matching_bags_total: 0,
    matching_bags_filter_query: null,
    matching_bags_loaded: false,
    similar_items_query: null,
    cart_count: 0,
    cart_items: [],
    cart_id: null,
    favorites_list: [],
    shopify_favorites_list: [],
    shopify_favorites_list_available: [],
    shopify_favorites_list_unavailable: [],
    shopify_product_not_found: false,
    isCartOpen: false,
    checkout: null,
    discount_error: null,
    discount_code: '',
    exchange_periods_values: [],
    temporary_shipping_rate: null,
    get_shopify_favorites_in_progress: true,
    recently_viewed_count: 0,
    is_cart_busy: false,
    color_variants: [],
    color_variants_products: [],
    available_color_variants: [],
    available_color_variants_products: [],
    size_variants: [],
    size_variants_products: [],
    available_size_variants: [],
    available_size_variants_products: [],
    trendingSearches: [],
    popularBags: [],
    searchDesignersCollections: [],
    searchTopMatches: [],
    defaultSearchTerms: [],
    defaultSearchProducts: [],
    defaultDesigners: [],
    suggestedSearchTerms: [],
    searchProductResults: [],
    suggestedDesigners: [],
    showSavedSearchesModal: false,
    savedSearchesModalType: 'save',
    savedSearchInputValue: '',
    appliedFilters: [],
    firstLookProducts: [],
    color_sizes: {color: [], size: []},
    others_recommendation_items: [],
    similar_recommendation_items: [],
    cart: null,
    isCartLoading: false,
    cartCount: 0,
    shipToUsOnly: false,
    tradeInItems: [],
    shouldShowGfyError: false,
    walletAccordion: false,
    forYouProducts: [],
    forYouFilters: {
        designers: [],
        categories: [],
        color: [],
        condition: [],
    },
    forYouAppliedFilters: {
        designers: [],
        categories: [],
        color: [],
        condition: [],
    },
    forYouFilteredProducts: [],
    shippingProtectionItem: null,
};

export default function appReducer(state=initialState, action) {
    switch (action.type) {
        case "SHOPIFY_PRODUCT_NOT_FOUND":
            return {
                ...state,
                shopify_product_not_found: true
            }
        case 'SET_ALL_PRODUCTS':
            return {
                ...state,
                products: [...action.payload.products],
                plpTotalProducts: action.payload.plpTotalProducts,
            };
        case 'SET_FIRST_LOOK_PRODUCTS':
            return {
                ...state,
                firstLookProducts: action.payload,
            };
        case 'GET_PRODUCT_BY_HANDLE':
            return {
                ...state,
                product: action.product
            };
        case 'GET_CUSTOM_PRODUCT_BY_HANDLE':
            return {
                ...state,
                product: action.product,
                selected_product: action.selected_product,
                selected_product_title: action.selected_product_title
            };
        case 'ADD_GC_TO_CART':
            return {
                ...state,
                selected_product: action.selected_product,
                selected_product_title: action.selected_product_title,
                selected_product_qty: action.selected_product_qty
            };
        case 'SCROLL_TO_REF':
            return {...state, current_ref: action.ref}
        case "SET_RECENTLY_VIEWED":
            return {
                ...state,
                recently_viewed_products: action.recently_viewed_products
            }
        case "SET_SIMILAR_SAME_DESIGNER":
            return {
                ...state,
                similar_to_products: action.products,
                similar_to_products_total: action.total_products,
                similar_to_filter_query: action.filter_query
            }
        case "SET_SIMILAR_SAME_DESIGNER_LOADED":
            return {
                ...state,
                similar_to_products_loaded: true,
            }
        case "SET_SIMILAR_BUY_IT_NOW":
            return {
                ...state,
                similar_buy_now_products: action.products,
                similar_buy_now_products_total: action.total_products,
                similar_buy_now_filter_query: action.filter_query
            }
        case "SET_SIMILAR_OTHER_DESIGNERS":
            return {
                ...state,
                similar_other_products: action.products,
                similar_other_products_total: action.total_products,
                similar_other_filter_query: action.filter_query
            }
        case "SET_SIMILAR_OTHER_DESIGNERS_LOADED":
            return {
                ...state,
                similar_other_products_loaded: true,
            }
        case "SET_MATCHING_ACCESSORIES":
            return {
                ...state,
                matching_accessories: action.products,
                matching_accessories_total: action.total_products,
                matching_accessories_filter_query: action.filter_query,
            }
        case "SET_MATCHING_ACCESSORIES_LOADED":
            return {
                ...state,
                matching_accessories_loaded: true,
            }
        case "SET_MATCHING_BAGS":
            return {
                ...state,
                matching_bags: action.products,
                matching_bags_total: action.total_products,
                matching_bags_filter_query: action.filter_query
            }
        case "SET_MATCHING_BAGS_LOADED":
            return {
                ...state,
                matching_bags_loaded: true,
            }
        case "SET_SIMILAR_ITEMS":
            return {
                ...state,
                similar_items_query: action.similar_items_query
            }
        case "SET_OTHERS_RECOMMENDATION_ITEMS":
            return {
                ...state,
                others_recommendation_items: action.payload
            }
        case "SET_SIMILAR_RECOMMENDATION_ITEMS":
            return {
                ...state,
                similar_recommendation_items: action.payload
            }
        case "CREATE_CART":
            return {
                ...state,
                checkout: action.checkout
            }
        case "ADDED_TO_CART":
            const new_cart_items = _.union(state.cart_items, [action.product_added_to_cart]);
            return {
                ...state,
                checkout: action.checkout,
                cart_items: new_cart_items,
                cart_count: new_cart_items.length,
                isCartOpen: action.isCartOpen,
                // item_added_to_cart: _.find(action.checkout.lineItems, (lineItem) => {
                //     return lineItem.variant.id === action.product_added_to_cart;
                // })
            }
        case "ADDED_MULTIPLE_TO_CART":
            return {
                ...state,
                checkout: action.checkout,
                cart_items: action.new_cart_items,
                cart_count: action.new_cart_items.length,
                isCartOpen: action.isCartOpen,
            }
        case "FORCE_ADDED_TO_CART":
            localStorage.setItem("cart_last_changed", Date.now().toString());
            return {
                ...state,
                checkout: action.checkout,
                cart_items: action.product_added_to_cart,
                cart_count: 1,
                isCartOpen: action.isCartOpen,
            }
        case "REMOVED_FROM_CART":
            localStorage.setItem("cart_last_changed", Date.now().toString());

            const remaining_cart_items = _.reject(state.cart_items, (cart_item) => {
                return cart_item === action.product_removed_from_cart;
            });
            return {
                ...state,
                checkout: action.checkout,
                cart_items: remaining_cart_items,
                cart_count: remaining_cart_items.length,
                isCartOpen: true,
            }
        case "REMOVED_FROM_CART_BULK":
            localStorage.setItem("cart_last_changed", Date.now().toString());

            const remaining_cart_items_bulk = _.difference(state.cart_items, action.product_removed_from_cart);
            return {
                ...state,
                checkout: action.checkout,
                cart_items: remaining_cart_items_bulk,
                cart_count: remaining_cart_items_bulk.length,
                isCartOpen: true,
            }
        case "SET_TEMPORARY_SHIPPING_RATE":
            return {
                ...state,
                temporary_shipping_rate: action.temporary_shipping_rate
            }
        case "CLOSE_CART":
            return {
                ...state,
                isCartOpen: false,
            }
        case "TOGGLE_CART":
            return {
                ...state,
                isCartOpen: action.payload,
            }
        case "RESET_CART":
            localStorage.setItem("cart_last_changed", Date.now().toString());

            return {
                ...state,
                checkout: null,
                cart_items: [],
                cart_count: 0,
                isCartOpen: action.isCartOpen || false,
            }
        case "GET_AFFIRM_MONTHLY_PAYMENT":
            return {
                ...state,
                affirm_monthly_payment: action.affirm_monthly_payment
            }
        case "GET_INFINITY_PRICES":
            return {
                ...state,
                infinity_prices: action.infinity_prices
            }
        case "SET_FAVORITE":
            const new_favs = state.favorites_list.slice();
            new_favs.push(action.product_id);
            return {
                ...state,
                favorites_list: new_favs
            }
        case "REMOVE_FAVORITE":
            return {
                ...state,
                favorites_list: _.without(state.favorites_list, action.product_id)
            }
        case "GET_SHOPIFY_FAVORITES":
            return {
                ...state,
                get_shopify_favorites_in_progress: true,
                favorites_count: action.favorites_count
            }
        case "SET_SHOPIFY_FAVORITES":
            return {
                ...state,
                shopify_favorites_list: action.shopify_favorites_list,
                shopify_favorites_list_available: action.shopify_favorites_list_available,
                shopify_favorites_list_unavailable: action.shopify_favorites_list_unavailable,
                get_shopify_favorites_in_progress: false
            }
        case "HANDLE_DISCOUNT_CODE":
            return {
                ...state,
                discount_error: action.discount_error || null,
                discount_code: action.discount_code || '',
                isCartOpen: true
            }
        case "GET_EXCHANGE_PERIODS_VALUES":
            return {
                ...state,
                exchange_periods_values: action.exchange_periods_values
            }
        case "GET_COLOR_SIZES":
            return {
                ...state,
                color_sizes: action.payload
            }
        case "REBAG_CREDIT":
            return {
                ...state,
                use_rebag_credit_request_in_progress: action.use_rebag_credit_request_in_progress
            }
        case "GET_RECENTLY_VIEWED_COUNT":
            return {
                ...state,
                recently_viewed_count: action.recently_viewed_count
            }
        case "GET_IN_CART_COUNT":
            return {
                ...state,
                in_cart_count: action.count,
                in_cart_count_item: action.product_id
            }
        case "SHOW_CART_BUSY":
            return {
                ...state,
                is_cart_busy: true
            }
        case "HIDE_CART_BUSY":
            return {
                ...state,
                is_cart_busy: false
            }
        case "SET_COLOR_VARIANTS":
            return {
                ...state,
                color_variants: action.all_label_variants,
                color_variants_products: action.all_label_variants_products,
                available_color_variants: action.available_label_variants,
                available_color_variants_products: action.available_label_variants_products,
            }
        case "SET_SIZE_VARIANTS":
            return {
                ...state,
                size_variants: action.all_label_variants,
                size_variants_products: action.all_label_variants_products,
                available_size_variants: action.available_label_variants,
                available_size_variants_products: action.available_label_variants_products,
            }
        case 'SET_TRENDING_SEARCHES':
            return {
                ...state,
                trendingSearches: action.payload
            }
        case 'SET_POPULAR_BAGS':
            return {
                ...state,
                popularBags: action.payload,
            }
        case 'SET_SEARCH_DESIGNERS_COLLECTIONS':
            return {
                ...state,
                searchDesignersCollections: action.payload,
            }
        case 'SET_SEARCH_TOP_MATCHES':
            return {
                ...state,
                searchTopMatches: action.payload,
            }
        case 'SET_DEFAULT_SEARCH_TERMS':
            return {
                ...state,
                defaultSearchTerms: action.payload
            }
        case 'SET_DEFAULT_SEARCH_PRODUCTS':
            return {
                ...state,
                defaultSearchProducts: action.payload,
            }
        case 'SET_DEFAULT_DESIGNERS':
            return {
                ...state,
                defaultDesigners: action.payload,
            }
        case 'SET_SUGGESTED_DESIGNERS':
            return {
                ...state,
                suggestedDesigners: action.payload,
            }
        case 'SET_SUGGESTED_SEARCH_TERMS':
            return {
                ...state,
                suggestedSearchTerms: action.payload,
            }
        case 'SET_SEARCH_PRODUCT_RESULTS':
            return {
                ...state,
                searchProductResults: action.payload,
            }
        case 'SET_SEARCH_TOTAL_PRODUCTS':
            return {
                ...state,
                plpTotalSearchProducts: action.payload,
            }
        case 'SHOW_SAVED_SEARCHES_MODAL':
            return {
                ...state,
                showSavedSearchesModal: action.payload.value,
                savedSearchesModalType: action.payload.type,
                savedSearchInputValue: action.payload.savedSearchInputValue,
            }
        case 'SET_SAVED_SEARCH_INPUT_VALUE':
            return {
                ...state,
                savedSearchInputValue: action.payload,
            }
        case 'SET_APPLIED_FILTERS':
            return {
                ...state,
                appliedFilters: action.payload,
            }
        case 'SET_IS_CART_LOADING':
            return {
                ...state,
                isCartLoading: action.payload
            }
        case 'UPDATE_SHOPIFY_CART':
            return {
                ...state,
                cart: action.payload.cart,
                cartCount: action.payload.cartCount || 0
            }

        case 'SET_TRADE_IN_ITEMS':
            return {
                ...state,
                tradeInItems: action.payload
            }
        case 'SET_SHIP_TO_US':
            return {
                ...state,
                shipToUsOnly: action.payload
            }
        case 'SET_GFY_ERROR':
            return {
                ...state,
                shouldShowGfyError: action.payload
            }
        case 'SET_WALLET_OPEN_ACCORDION':
            return {
                ...state,
                walletAccordion: action.payload
            }
        case 'SET_FOR_YOU_PRODUCTS':
            return {
                ...state,
                forYouProducts: action.payload.forYouProducts,
                forYouFilteredProducts: action.payload.forYouProducts,
                forYouFilters: action.payload.forYouFilters
            }
        case 'SET_FOR_YOU_APPLIED_FILTERS':
            return {
              ...state,
              forYouAppliedFilters: action.payload.forYouAppliedFilters,
              forYouFilteredProducts: action.payload.forYouFilteredProducts
            }
        case 'CLEAR_ALL_APPLIED_FILTERS':
            return {
                ...state,
                forYouFilteredProducts: state.forYouProducts,
                forYouAppliedFilters: action.payload.forYouAppliedFilters
            }
        case 'SHIPPING_PROTECTION_ITEM':
            return {
                ...state,
                shippingProtectionItem: action.payload
            }
        default:
            return state;
    }
};